import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const ConfirmActionModal = ({
  show,
  title = 'Please confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'primary',
  busy = false,
  onCancel,
  onConfirm,
}) => (
  <Modal show={show} onHide={busy ? undefined : onCancel} centered backdrop="static">
    <Modal.Header closeButton={!busy}>
      <Modal.Title as="h5">{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="mb-0" style={{ whiteSpace: 'pre-line' }}>{message}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onCancel} disabled={busy}>
        {cancelLabel}
      </Button>
      <Button variant={variant} onClick={onConfirm} disabled={busy}>
        {busy ? 'Please wait...' : confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmActionModal;
